import axios from "axios";
import { toCamelCase } from "../utils/objectHelper";
import { StatsSites, StatsSiteschema, TStats } from "../types/statsSite";

export const StatsSiteTranporter = {
    list: async (stat: TStats, siteId: number): Promise<Array<StatsSites>> => {
        const { data } = await axios.get(`/statsSite/${stat}/${siteId}`, {});
        return data.map((current: any) => {
            return StatsSiteschema.cast(toCamelCase(current), { stripUnknown: true });
        });
    },
};
